import middleware from "../../middleware";
import api from "../../service";

class permissionService extends middleware {
	constructor() {
		super();
		this.url = `${api.defaults.baseURL}`;
	}
	async userPermissions() {
		if (this.params.user_type === "student") {
			const response = {
				data: { userType: "student" },
			};
			return response;
		}
		const response = await api.get(`${this.url}/userPermissions`);
		return response;
	}
	// Route::get('/userModules/{module}', [PermissionController::class, 'userModules']);

	async userModulePermission(module) {
		if (this.params.user_type === "student") {
			const response = {
				data: { userType: "student" },
			};
			return response;
		}
		const response = await api.get(`${this.url}/userModules/${module}`);
		return response;
	}

	async userCan(permission) {
		if (this.params.user_type === "student") {
			const response = {
				data: { userType: "student" },
			};
			return response;
		}
		const response = await api.get(
			`${api.defaults.baseURL}/userCan/${permission}`,
		);
		return response;
	}
}

export default permissionService;
